import { trans } from "@mongez/localization";
import { cartAtom } from "core/cart";
import { LoadingState } from "core/shared";
import { CartDrawerItem } from "./CartDrawerItem";

export function CartDrawerItems() {
  const cart = cartAtom.use("cart");

  if (!cart) return null;

  if (cart.state === LoadingState.LOADING) {
    return <p>{trans("loading")}</p>;
  }

  return (
    <div className="px-10">
      <div className="flex flex-col gap-4 py-6">
        {cart.items.map((item) => (
          <CartDrawerItem key={item.id} {...item} />
        ))}
      </div>
    </div>
  );
}
